/** First non-empty line of multi-line text, trimmed and capped for use as a title. */
export function firstLine(text: string, max = 140): string {
  const line = (text || "").split(/\r?\n/).find((l) => l.trim()) ?? "";
  const t = line.trim();
  return t.length > max ? `${t.slice(0, max - 1)}…` : t;
}
